<template>
  <el-popover id="feedlotPopover" placement="bottom" width="300" trigger="click">
    <div class="row">
      <div class="col-md-12 mb-3">
        <label>Nickname</label>
        <el-input size="small" placeholder="Please input" v-model="short_name" class="input-with-select">
          <el-button slot="append" icon="el-icon-edit" @click="saveBusiness"></el-button>
        </el-input>
      </div>
    </div>
    <a href="#" slot="reference" @click.prevent><i class="fa fa-pencil has-interaction link-primary px-2"></i></a>
  </el-popover>
</template>

<script>
import Business from "../../../modelsPortal/Business";
export default {
  props: {
    initial_business: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      short_name: this.initial_business.short_name,
    };
  },
  computed: {

  },
  created() {
  },
  mounted() {
  },
  methods: {
    saveBusiness() {
      new Business({ id: this.initial_business.id, short_name: this.short_name })
        .save()
        .then((result) => {
          this.$emit('refresh', this.short_name);
          this.$message.success('Saved Successfully!');
        }).catch((errors) => {
          this.form.errors.record(errors.response.data.errors);
        });
    }
  }
};
</script>